





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getGiftList, sendGift } from '@/api/Anchor'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import TimInstance from 'utils/imbase/index';
import TIM from 'tim-js-sdk';
import { msgTypeEnum } from '@/store/types'

import { chunk, get as getProps } from "lodash";
import { redirectUrlPrefix, redirectTo } from '../utils'
import 'swiper/dist/css/swiper.css'
import { Toast } from 'vant';
@Component({
  components: {
    swiper,
    swiperSlide
  },
})
export default class GiftList extends Vue {
  @Prop() private roomId!: string;
  @Prop() private disabledTime!: boolean;
  @Prop({
    type: Boolean,
    default: false
  }) private canPay!: boolean;
  private giftListData = []

  private created () {
    this.getGiftList()
  }

  private async getGiftList () {
    const res = await getGiftList(this.roomId, this.$store.state.sid, this.$store.state.appId)
    this.giftListData = chunk(getProps(res, 'body.gifts', []), 8)
  }
  private get swiperOption () {
    return ({
      pagination: '.swiper-pagination',
      paginationClickable: true,
    })
  }
  private get userInfo () {
    return this.$store.state.userInfo
  }
  private async sendGift (gift) {
    if (this.disabledTime && !gift.giftPrice) {
      Toast('倒计时结束后可以继续送礼哦~')
      return
    }
    const { businessType } = this.$route.query
    if (!this.canPay && gift.giftPrice > 0) {
      this.$weui.dialog({
        title: '提示',
        // content: '请到app去赠送礼物',
        content:  businessType === '1' ? '亲，请安装并打开【平安好车主】\nAPP前往直播间赠送礼物~' : '请到app去赠送礼物',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {
              // 好车主直接跳转配置页面
              const { redirectUrl } = this.$route.query
              if (redirectUrl) {
                redirectTo(redirectUrlPrefix(redirectUrl))
                return
              }
              console.log('确定')
            }
        }]
      })
      return
    }
    const res = await sendGift({
      sid: this.$store.state.sid,
      nonGzip: 1,
      giftCode: gift.giftCode,
      roomId: this.roomId,
      appId: this.$store.state.appId,
      giftCount: 1,
      canalType: 1,
      userName: this.userInfo.userName,
      empId: this.userInfo.empId,
      fullPathCN: this.userInfo.allFullPathCn,
      dataSource: 0,
      liveKind: 0
    })
    if (+res.code === 0) {
      const message = {
        name: this.userInfo.userName,
        message:  `1${gift.giftUnit}${gift.giftName}`,
        msgType: msgTypeEnum.GIFT_MSG
      }
      this.$store.dispatch('updateLiveRoomMsg', message)
      this.sendImMsg(gift)
      this.$emit('checkGiftDisable', gift)
    } else
      if (this.canPay) {
        this.$weui.dialog({
          title: '提示',
          content: res.message,
          buttons: [{
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.$emit('showGiftListBtnClicked')
              }
          }]
        })
      }
  }

  private sendImMsg (gift) {
    const message = TimInstance.tim.createCustomMessage({
      to: this.roomId,
      conversationType: TIM.TYPES.CONV_GROUP,
      payload: {
        data: JSON.stringify({
          userAction: 6,
          actionParam: JSON.stringify({
            cartoonId: gift.cartoonId,
            giftCode: gift.giftCode,
            giftCount: 1,
            giftName: gift.giftName,
            giftPic: gift.giftPic,
            giftPrice: gift.giftPrice,
            giftUnit: gift.giftUnit,
          }),
          Content: gift.giftName,
          NickName: this.userInfo.userName,
          HeadUrl: this.userInfo.userImg,
          Company: this.userInfo.allFullPathCn,
          RoomId: this.roomId,
          MuteUserId: '',
        })
      }
    });
    let promise = TimInstance.tim.sendMessage(message);
  }
}
